export interface ITableHeadingProps {
    thClass?: string;
    heading: string;
    attribute: string;
}


export interface ITableSectionProps {
    trClass?: string;
    rowLabel?: string;
    rowData: ITableRowProps[];
}

export interface ITableRowProps {
    trClass?: string;
    tdClass?: string;
    disableClick?: boolean;
    [attribute: string]: any;
}

export interface ITableDataProps {
    head: Array<ITableHeadingProps>;
    body: Array<ITableSectionProps>;
    foot: Array<ITableSectionProps>;
    footClass?: string,
    seperated?: Array<ITableSectionProps>;
}

export enum RowType {
    body = 'body',
    footer = 'footer',
    seperated = 'seperated',
}